import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels';
import { SingleSetPromotionModule, SingleSetPromotionLogic, SingleSetPromotionStates } from '@gongxigames/framework/promotions';

export class SingleSetPromotionInProgressState extends ModuleState<
    null,
    SingleSetPromotionModule,
    GlobalEventsMapForBackwardCompatibility
> {
    private isRoundInProgress = false;
    private isSpinDisabled = false;

    public onEnterState(): void {
        this.isSpinDisabled = false;
        this.isRoundInProgress = !this.module.nextActionIsSpin;
        this.module.activateCounter();
    }

    public onLeaveState(): void {
        this.promotion.end();
        this.emit('General.Promotion.Campaign.Ended');
        this.emit('General.Promotion.DeactivateCounter');
    }

    protected setupEvents(): void {
        this.setEventHandler(LogicEvents.ROUND_START, this.onPaidRoundStarted.bind(this));
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted.bind(this));
        this.setEventHandler(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(LogicEvents.BALANCE_UPDATED, this.onUpdatedBalance.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    private onResponse(): void {
        if (this.promotion.isEndOfPromotion()) {
            this.emit('General.Slot.SPIN.DISABLE', SingleSetPromotionModule.NAME);
            this.isSpinDisabled = true;
        }
    }
    private onSpinStarted(): void {
        if (this.promotion.isNextPromotion()) {
            this.promotion.subtractPromotion();
            this.module.updateCounter();
        }
    }

    private onAllReelsStopped(): void {
        if (this.promotion.isLastPromotion()) {
            this.emit('Autoplay.FORCE_STOP');
        }
    }

    private onPaidRoundStarted(): void {
        this.isRoundInProgress = true;
    }

    private onPaidRoundEnded(): void {
        if (this.isRoundInProgress) {
            this.isRoundInProgress = false;

            if (this.isSpinDisabled) {
                this.isSpinDisabled = false;
                this.emit('General.Slot.SPIN.ENABLE', SingleSetPromotionModule.NAME);
            }

            if (this.promotion.isEndOfPromotion()) {
                this.emit('General.Slot.SPIN.ENABLE', SingleSetPromotionModule.NAME);
                this.module.gotoState(SingleSetPromotionStates.BASIC);
                this.emit('General.Promotion.Ended');
            }
        }
    }

    private onUpdatedBalance(): void {
        if (this.promotion.isEndOfPromotion() && !this.isRoundInProgress) {
            this.module.gotoState(SingleSetPromotionStates.BASIC);
            this.emit('General.Promotion.Ended');
        } else {
            this.module.updateCounter();
        }
    }

    private get promotion(): SingleSetPromotionLogic {
        return this.module.getPromotion<SingleSetPromotionLogic>();
    }
}
